import { Inject, NgModule } from '@angular/core';
import { APOLLO_OPTIONS, Apollo, ApolloModule } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache } from '@apollo/client/core';
import introspectionResult from 'graphql-api/gql-api-fragments';

import { defaultOptions, GraphqlApis, GRAPHQL_API } from './tokens';

@NgModule({
  imports: [ApolloModule],
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: (httpLink: HttpLink, graphqlApi: GraphqlApis) => {
        return {
          cache: new InMemoryCache({
            possibleTypes: introspectionResult.possibleTypes,
          }),
          defaultOptions: defaultOptions.productsApi,
          link: httpLink.create({
            uri: graphqlApi.productsApi,
          }),
        };
      },
      deps: [HttpLink, GRAPHQL_API],
    },
  ],
})
export class GraphqlModule {
  constructor(
    @Inject(GRAPHQL_API) graphqlApis: GraphqlApis,
    apollo: Apollo,
    httpLink: HttpLink,
  ) {
    const { productsApi, ...otherAPIs } = { ...graphqlApis };
    // The default client is created using the APOLLO_OPTIONS Provider, additional clients are created here
    Object.keys(otherAPIs).forEach((apiName: string) => {
      apollo.createNamed(apiName, {
        link: httpLink.create({ uri: otherAPIs[apiName] }),
        cache: new InMemoryCache(),
        defaultOptions: defaultOptions[apiName],
      });
    });
  }
}
